// shared components
import { DataGridToolbar } from '@/components/ui/datagrid/DataGridToolbar';

// feature-components
import {
  ExpandCollapseButton,
  FavoritesButton,
  FullscreenButton,
  PivotViewButton,
} from '@/features/energyxplorer/portfolio/components/datagrid/PortfolioToolbarButtons';

interface PortfolioAnalysisToolbarProps {
  handleFavoritesFilterClick: (value: boolean) => void;
  isFavoritesFiltered: boolean;
  setIsFavoritesFiltered: (value: boolean) => void;
  handleExpandCollapse: () => void;
  isCollapsed: boolean;
}

const PortfolioAnalysisToolbar = ({
  handleFavoritesFilterClick,
  isFavoritesFiltered,
  setIsFavoritesFiltered,
  handleExpandCollapse,
  isCollapsed,
}: PortfolioAnalysisToolbarProps) => {
  const handleFavoritesToggle = (newValue: boolean) => {
    handleFavoritesFilterClick(newValue);
    setIsFavoritesFiltered(newValue);
  };

  return (
    <DataGridToolbar
      showColumns
      showFilters
      showExport
      showExcelExport
      showQuickFilter
      showDivider
    >
      <FullscreenButton />
      <PivotViewButton />
      <ExpandCollapseButton
        isCollapsed={isCollapsed}
        onToggle={handleExpandCollapse}
      />
      <FavoritesButton
        isFavoritesFiltered={isFavoritesFiltered}
        onToggle={handleFavoritesToggle}
      />
    </DataGridToolbar>
  );
};

export default PortfolioAnalysisToolbar;
